<!-- 覆蓋層背景 -->
<div class="overlay-backdrop" (click)="onClose()">
  <!-- 彈出視窗容器 -->
  <div class="law-compare-container" (click)="$event.stopPropagation()">
    <!-- 標題列 -->
    <div class="compare-header">
      <h2>{{ 'regulation.update.title' | translate }}</h2>      <div class="header-controls">
        <button class="comparison-btn"
                [class.active]="isComparisonEnabled"
                (click)="toggleComparison()"
                [title]="isComparisonEnabled ? '關閉條次比對' : '啟用條次比對'">
          <i class="fa-solid" [class.fa-search]="!isComparisonEnabled" [class.fa-search-minus]="isComparisonEnabled"></i>
          <span>{{ isComparisonEnabled ? '隱藏差異比對' : '顯示差異比對' }}</span>
        </button>
        <button class="sync-btn"
                [class.active]="isSyncScrollEnabled"
                (click)="toggleSyncScroll()"
                [title]="isSyncScrollEnabled ? '點擊停用同步捲動' : '點擊啟用同步捲動'">
          <i class="fa-solid" [class.fa-link]="isSyncScrollEnabled" [class.fa-unlink]="!isSyncScrollEnabled"></i>
          <span>{{ isSyncScrollEnabled ? '同步已啟用' : '同步捲動' }}</span>
        </button>
        <button class="close-btn" (click)="onClose()">
          <i class="fa-solid fa-times"></i> {{ 'regulation.update.cancel' | translate }}
        </button>
      </div>
    </div>

    <!-- 比較內容區域 -->
    <div class="compare-content">
      <!-- 左側：現有法規資訊 -->
      <div class="compare-panel left-panel">
        <div class="panel-header">
          <h3>
            <i class="fa-solid fa-file-lines"></i>
            {{ 'regulation.update.current_version' | translate }}
          </h3>
          <div class="version-info">
            <span class="date-badge current">
              {{ formatDate(selectedLaw?.law_modified_date) }}
            </span>
          </div>
        </div>

        <div class="law-details" #leftScrollContainer (scroll)="onLeftScroll($event)">
          <!-- 法規基本資訊 -->
          <div class="law-info-section">
            <h4>基本資訊</h4>
            <div class="info-row">
              <label>法規名稱：</label>
              <div class="info-value">
                <a [href]="selectedLaw?.law_url" target="_blank" class="law-link">
                  {{ selectedLaw?.law_name || '未設定' }}
                </a>
              </div>
            </div>
            <div class="info-row">
              <label>最後修改日期：</label>
              <span class="info-value">{{ formatDate(selectedLaw?.law_modified_date) }}</span>
            </div>
            <div class="info-row">
              <label>法規層級：</label>
              <span class="info-value">{{ selectedLaw?.law_hierarchy || '未設定' }}</span>
            </div>
            <div class="info-row">
              <label>法條數量：</label>
              <span class="info-value">{{ getActualArticleCount(selectedLaw?.law_articles) }} 條</span>
            </div>
          </div>

          <!-- 法條內容 -->
          <div class="articles-section">
            <h4>法條內容</h4>
            <div class="articles-list">
              <div *ngIf="selectedLaw?.law_articles?.length > 0; else noArticles">                <!-- 左側：現有法規資訊 -->
                <div *ngFor="let article of selectedLaw.law_articles; let i = index"
                     class="article-item"
                     [ngClass]="{'chapter-item': isChapter(article), 'article-item': !isChapter(article)}">


                  <div *ngIf="isChapter(article)" class="chapter-header">
                      <h5>{{ article.article_content}}</h5>
                    </div>

                  <!-- 一般法條顯示 -->
                  <div *ngIf="!isChapter(article)"
                       [ngClass]="getArticleStatusClass(article, false)">
                    <div class="article-header">
                      <strong>{{ article.article_no || (i + 1) }}</strong>
                      <span *ngIf="article.article_name" class="article-name">
                        {{ article.article_name }}
                      </span>
                      <!-- 條次狀態標籤 -->
                      <span *ngIf="isComparisonEnabled && getArticleStatusLabel(article, false)"
                            class="status-label"
                            [ngClass]="getArticleStatusClass(article, false)">
                        {{ getArticleStatusLabel(article, false) }}
                      </span>
                    </div>                    <div class="article-content">
                      <!-- 左側始終顯示原始內容，不顯示差異標示 -->
                      <div [innerHTML]="article.article_content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noArticles>
                <div class="no-data">暫無法條資料</div>
              </ng-template>
            </div>
          </div>
        </div>


      </div>

      <!-- 右側：最新版本法規資訊 -->
      <div class="compare-panel right-panel">
        <div class="panel-header">
          <h3>
            <i class="fa-solid fa-download"></i>
            {{ 'regulation.update.latest_version' | translate }}
          </h3>
          <div class="version-info">
            <span class="date-badge new" *ngIf="newVersionLaw?.law_modified_date">
              {{ formatDate(newVersionLaw.law_modified_date) }}
            </span>
          </div>
        </div>

        <div class="law-details" #rightScrollContainer (scroll)="onRightScroll($event)">
          <!-- 載入中狀態 -->
          <div *ngIf="isLoadingNewVersion" class="loading-state">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <span>{{ 'regulation.update.loading' | translate }}</span>
          </div>

          <!-- 載入錯誤狀態 -->
          <div *ngIf="loadError" class="error-state">
            <i class="fa-solid fa-exclamation-triangle"></i>
            <span>{{ loadError }}</span>
            <button class="retry-btn" (click)="fetchNewVersionLaw()">
              <i class="fa-solid fa-refresh"></i> {{ 'regulation.update.retry' | translate }}
            </button>
          </div>

          <!-- 成功載入最新版本 -->
          <ng-container *ngIf="!isLoadingNewVersion && !loadError && newVersionLaw">
            <!-- 法規基本資訊 -->
            <div class="law-info-section">
              <h4>基本資訊</h4>
              <div class="info-row">
                <label>法規名稱：</label>
                <div class="info-value">
                  <a [href]="selectedLaw?.law_url" target="_blank" class="law-link">
                    {{ newVersionLaw.law_name || '未設定' }}
                  </a>
                </div>
              </div>
              <div class="info-row">
                <label>最後修改日期：</label>
                <span class="info-value">{{ formatDate(newVersionLaw.law_modified_date) }}</span>
              </div>
              <div class="info-row">
                <label>法規層級：</label>
                <span class="info-value">{{ newVersionLaw.law_hierarchy || '未設定' }}</span>
              </div>
              <div class="info-row">
                <label>法條數量：</label>
                <span class="info-value">{{ getActualArticleCount(newVersionLaw.law_articles) }} 條</span>
              </div>
            </div>

            <!-- 法條內容 -->
            <div class="articles-section">
              <h4>法條內容</h4>
              <div class="articles-list">                <!-- 右側：最新版本法規資訊 -->
                <div *ngIf="newVersionLaw.law_articles?.length > 0; else noNewArticles">
                  <div *ngFor="let article of newVersionLaw.law_articles; let i = index"
                       class="article-item"
                       [ngClass]="{'chapter-item': isChapter(article), 'article-item': !isChapter(article)}">



                    <!-- 章節顯示 -->
                    <div *ngIf="isChapter(article)" class="chapter-header">
                      <h5>{{ article.article_content}}</h5>
                    </div>

                    <!-- 一般法條顯示 -->
                    <div *ngIf="!isChapter(article)"
                         [ngClass]="getArticleStatusClass(article, true)">                      <div class="article-header">
                        <strong>{{ article.article_no || (i + 1) }}</strong>
                        <!-- 顯示原條次資訊 -->
                        <span *ngIf="getOriginalArticleInfo(article, true)" class="original-article-info">
                          (原 {{ getOriginalArticleInfo(article, true) }} )
                        </span>
                        <span *ngIf="article.article_name" class="article-name">
                          {{ article.article_name }}
                        </span>
                        <!-- 條次狀態標籤 -->
                        <span *ngIf="isComparisonEnabled && getArticleStatusLabel(article, true)"
                              class="status-label"
                              [ngClass]="getArticleStatusClass(article, true)">
                          {{ getArticleStatusLabel(article, true) }}
                        </span>
                      </div>
                      <div class="article-content">
                        <!-- 原始內容或差異標示 -->
                        <ng-container *ngIf="!isComparisonEnabled || !getComparisonResult(article, true)?.changes">
                          <div [innerHTML]="article.article_content"></div>
                        </ng-container>                        <!-- 差異標示內容 -->
                        <ng-container *ngIf="isComparisonEnabled && getComparisonResult(article, true)?.changes">
                          <div class="diff-content">
                            <ng-container *ngFor="let change of getComparisonResult(article, true).changes">
                              <span *ngIf="change.type === 'normal'" class="diff-normal">{{change.text}}</span>
                              <span *ngIf="change.type === 'deletion'" class="diff-deletion-ghost" title="此部分在舊版本中被刪除">{{change.text}}</span>
                              <span *ngIf="change.type === 'insertion'" class="diff-inserted" title="此部分在新版本中新增">{{change.text}}</span>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noNewArticles>
                  <div class="no-data">暫無法條資料</div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- AI總結面板 -->
    <div class="ai-summary-panel" *ngIf="showAISummary">
      <div class="summary-header">
        <h3>
          <i class="fa-solid fa-robot"></i>
          AI 法規異動總結
        </h3>
        <button class="close-summary-btn" (click)="closeAISummary()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>

      <div class="summary-content">
        <!-- 載入中狀態 -->
        <div *ngIf="isLoadingAISummary" class="loading-state">
          <div class="loading-spinner">
            <i class="fa-solid fa-robot fa-spin"></i>
          </div>
          <p>正在生成 AI 分析摘要，請稍候...</p>
          <small>此過程可能需要 10-30 秒</small>
        </div>

        <!-- AI總結內容 -->
        <div *ngIf="!isLoadingAISummary && aiSummaryData" class="summary-sections">
          <!-- 1. 變更統計 -->
          <div class="change-statistics">
            <h4>本次異動統計</h4>
            <div class="stats-grid">
              <div class="stat-item added" *ngIf="getChangeStatistics().added.length > 0">
                <div class="stat-label">新增條次</div>
                <div class="stat-value">{{ getChangeStatistics().added.join('、') }}</div>
                <div class="stat-count">(共 {{ getChangeStatistics().added.length }} 條)</div>
              </div>

              <div class="stat-item modified" *ngIf="getChangeStatistics().modified.length > 0">
                <div class="stat-label">異動條次</div>
                <div class="stat-value">{{ getChangeStatistics().modified.join('、') }}</div>
                <div class="stat-count">(共 {{ getChangeStatistics().modified.length }} 條)</div>
              </div>

              <div class="stat-item deleted" *ngIf="getChangeStatistics().deleted.length > 0">
                <div class="stat-label">刪除條次</div>
                <div class="stat-value">{{ getChangeStatistics().deleted.join('、') }}</div>
                <div class="stat-count">(共 {{ getChangeStatistics().deleted.length }} 條)</div>
              </div>
            </div>
          </div>

          <!-- 2. AI分析摘要 -->
          <div class="ai-analysis">
            <h4> AI 分析摘要</h4>
            <div class="analysis-content">
              <div class="analysis-section">
                <h5>完整分析報告</h5>
                <div class="summary-content" [innerHTML]="formatAISummary(aiSummaryData.summary)"></div>
              </div>

              <!-- <div class="analysis-section" *ngIf="aiSummaryData.impact && aiSummaryData.impact !== '請參考完整AI總結內容'">
                <h5>影響評估</h5>
                <div [innerHTML]="formatAISummary(aiSummaryData.impact)"></div>
              </div>

              <div class="analysis-section" *ngIf="aiSummaryData.recommendations && aiSummaryData.recommendations !== '請參考完整AI總結內容'">
                <h5>建議事項</h5>
                <div [innerHTML]="formatAISummary(aiSummaryData.recommendations)"></div>
              </div> -->

              <!-- 顯示元數據 -->
              <!-- <div class="analysis-metadata" *ngIf="aiSummaryData.metadata">
                <div class="metadata-info">
                  <small>
                    <i class="fa-solid fa-info-circle"></i>
                    分析模型: {{ aiSummaryData.model_used || 'gpt-4o-mini' }} |
                    回應ID: {{ aiSummaryData.ai_response_id || '未知' }}
                  </small>
                </div>
              </div> -->
            </div>
          </div>

          <!-- 3. 使用者註解區 -->
          <div class="user-comment-section">
            <h4>您的備註</h4>
            <div class="comment-input-area">
              <textarea
                [(ngModel)]="userComment"
                placeholder="請在此輸入您對本次法規異動的備註或意見..."
                rows="4"
                class="comment-textarea">
              </textarea>
              <div class="comment-actions">
                <button class="btn btn-outline-primary" (click)="saveUserComment()">
                  <i class="fa-solid fa-save"></i>
                  儲存備註
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 操作按鈕區域 -->
    <div class="action-buttons" *ngIf="!isLoadingNewVersion && !loadError && newVersionLaw">
      <!-- 左側：AI總結按鈕 -->
      <div class="left-buttons">
        <button class="ai-summary-btn"
                [class.active]="showAISummary"
                (click)="toggleAISummary()"
                [disabled]="!newVersionLaw || comparisonResults.size === 0">
          <i class="fa-solid fa-robot"></i>
          <span>AI總結</span>
        </button>
      </div>

      <!-- 右側：操作按鈕 -->
      <div class="right-buttons">
        <button class="btn btn-secondary" (click)="onClose()">
          <i class="fa-solid fa-times"></i> {{ 'regulation.update.cancel' | translate }}
        </button>
        <button class="btn btn-primary" (click)="confirmUpdate()">
          <i class="fa-solid fa-download"></i> {{ 'regulation.update.confirm' | translate }}
        </button>
      </div>
    </div>
  </div> <!-- 關閉 law-compare-container -->
</div> <!-- 關閉 overlay-backdrop -->
